import CognitionIcon from '/public/icons/cognition.svg'
import Face3Icon from '/public/icons/face_3.svg'
import VisibilityIcon from '/public/icons/visibility.svg'
import BloodTypeIcon from '/public/icons/bloodtype.svg'
import StaightenIcon from '/public/icons/straighten.svg'
import MonitorWeightIcon from '/public/icons/monitor_weight.svg'
import ManIcon from '/public/icons/man.svg'
import BlurCircularIcon from '/public/icons/blur_circular.svg'
import BubbleChartIcon from '/public/icons/bubble_chart.svg'
import EventAvailableIcon from '/public/icons/event_available.svg'
import HairTypeIcon from '/public/icons/hair_type.svg'
import BodyBuildIcon from '/public/icons/body_build.svg'
import OwnChildrenIcon from '/public/icons/children.svg'
import CounsellingIcon from '/public/icons/counselling.svg'
import QuarantineIcon from '/public/icons/quarantine.svg'
import LanguageIcon from '/public/icons/language.svg'
import VerifiedUserIcon from '/public/icons/verified_user.svg'
import NoseIcon from '/public/icons/nose.svg'
import ForeheadIcon from '/public/icons/forehead.svg'
import FaceIcon from '/public/icons/face.svg'
import HoroscopeIcon from '/public/icons/horoscope.svg'
import FamilyHistoryIcon from '/public/icons/family_history.svg'
import LocalHospitalIcon from '/public/icons/local_hospital.svg'
import ScheduleIcon from '/public/icons/schedule.svg'

export interface FiltersButtonProps {
  label?: string
}

//TODO: here we add all donorTraits
export const DonorTraitTypes = {
  race: 'race',
  hairType: 'hair_type',
  eyeType: 'eye_type',
  bloodType: 'blood_type',
  height: 'height',
  weight: 'weight',
  bmi: 'bmi',
  oocytesAvailable: 'oocytes_available',
  bodyBuild: 'body_build',
  hairTexture: 'hair_texture',
  oocytesProgram: 'oocytes_program',
  vialsProgram: 'vials_program',
  counselling: 'counselling',
  availabilityStatus: 'availability_status',
  quarantine: 'quarantine',
  language: 'language',
  familyLimits: 'family_limits',
  canadaProgram: 'canada_program',
  available: 'available',
  availableUsa: 'available_USA',
  availableAustralia: 'available_Australia',
  ownChildren: 'own_children',
  vaccinationCovid19: 'vaccination_covid19',
  quarantineStatus: 'quarantine_status',
  ethnicity: 'ethnicity',

  // SPERM DONOR
  nose: 'nose',
  forehead: 'forehead',
  faceShape: 'face_shape',
  lipsShape: 'lips_shape',
  horoscope: 'horoscope'
} as const

//TODO: here we add all donorTraits
export const DonorTraitIcons = {
  [DonorTraitTypes.race]: CognitionIcon,
  [DonorTraitTypes.hairType]: Face3Icon,
  [DonorTraitTypes.eyeType]: VisibilityIcon,
  [DonorTraitTypes.bloodType]: BloodTypeIcon,
  [DonorTraitTypes.height]: StaightenIcon,
  [DonorTraitTypes.weight]: MonitorWeightIcon,
  [DonorTraitTypes.bmi]: ManIcon,
  [DonorTraitTypes.oocytesAvailable]: BlurCircularIcon,
  [DonorTraitTypes.bodyBuild]: BodyBuildIcon,
  [DonorTraitTypes.hairTexture]: HairTypeIcon,
  [DonorTraitTypes.oocytesProgram]: BubbleChartIcon,
  [DonorTraitTypes.vialsProgram]: BubbleChartIcon,
  [DonorTraitTypes.counselling]: CounsellingIcon,
  [DonorTraitTypes.availabilityStatus]: EventAvailableIcon,
  [DonorTraitTypes.quarantine]: QuarantineIcon,
  [DonorTraitTypes.language]: LanguageIcon,
  [DonorTraitTypes.familyLimits]: FamilyHistoryIcon,
  [DonorTraitTypes.canadaProgram]: LocalHospitalIcon,
  [DonorTraitTypes.available]: ScheduleIcon,
  [DonorTraitTypes.availableUsa]: ScheduleIcon,
  [DonorTraitTypes.availableAustralia]: ScheduleIcon,
  [DonorTraitTypes.ownChildren]: OwnChildrenIcon,
  [DonorTraitTypes.vaccinationCovid19]: VerifiedUserIcon,
  [DonorTraitTypes.quarantineStatus]: QuarantineIcon,
  [DonorTraitTypes.ethnicity]: CognitionIcon,
  [DonorTraitTypes.nose]: NoseIcon,
  [DonorTraitTypes.forehead]: ForeheadIcon,
  [DonorTraitTypes.faceShape]: FaceIcon,
  [DonorTraitTypes.lipsShape]: FaceIcon,
  [DonorTraitTypes.horoscope]: HoroscopeIcon
} as const

export type DonorTraitType =
  (typeof DonorTraitTypes)[keyof typeof DonorTraitTypes]

export type DonorTraitKey = keyof typeof DonorTraitTypes

export type MappedDonorTraitTypes = {
  [K in keyof typeof DonorTraitTypes]: (typeof DonorTraitTypes)[K]
}

export type DonorTraitsType = {
  [K in MappedDonorTraitTypes[keyof MappedDonorTraitTypes]]?: DonorTraitType
}
